// extracted by mini-css-extract-plugin
export default {"Header":"PropertyViewLayout_Header__hVxno","Tabs":"PropertyViewLayout_Tabs__Xjs+y","PropertyBlock":"PropertyViewLayout_PropertyBlock__Q1iEQ"};